import capitalize from 'lodash-es/capitalize'

import { YEAR_FIRST_MONTH, YEAR_LAST_MONTH } from '../../../constants/date'

/**
 * @typedef {Object} MonthSelectOption
 * @property {string} label
 * @property {number} value
 * @property {boolean} [disabled]
 */

/**
 * @param {number} value
 * @param locale
 *
 * @returns {MonthSelectOption}
 */
export function getMonthSelectOption(value, locale) {
  return {
    label: capitalize(locale.localize.month(value)),
    value,
  }
}

/**
 * @param {number} minValue
 * @param {number} maxValue
 * @param locale
 *
 * @returns {MonthSelectOption[]}
 */
export function getMonthSelectOptions(locale, minValue, maxValue) {
  const first = Math.max(minValue, YEAR_FIRST_MONTH)
  const last = Math.min(maxValue, YEAR_LAST_MONTH)

  return Array.from({ length: last - first + 1 }, (_, index) =>
    getMonthSelectOption(first + index, locale)
  )
}

export function getDatePickerMonthOptions(t) {
  return [
    { isPersistent: true, label: t('Date.JanuaryMonthKey'), value: 0 },
    { isPersistent: true, label: t('Date.FebruaryMonthKey'), value: 1 },
    { isPersistent: true, label: t('Date.MarchMonthKey'), value: 2 },
    { isPersistent: true, label: t('Date.AprilMonthKey'), value: 3 },
    { isPersistent: true, label: t('Date.MayMonthKey'), value: 4 },
    { isPersistent: true, label: t('Date.JuneMonthKey'), value: 5 },
    { isPersistent: true, label: t('Date.JulyMonthKey'), value: 6 },
    { isPersistent: true, label: t('Date.AugustMonthKey'), value: 7 },
    { isPersistent: true, label: t('Date.SeptemberMonthKey'), value: 8 },
    { isPersistent: true, label: t('Date.OctoberMonthKey'), value: 9 },
    { isPersistent: true, label: t('Date.NovemberMonthKey'), value: 10 },
    { isPersistent: true, label: t('Date.DecemberMonthKey'), value: 11 },
  ]
}
